<app-header *ngIf="isSearchFromHome === constants.FALSE" class="view-header"></app-header>

<app-header-no-session *ngIf="isSearchFromHome === constants.TRUE" class="view-header"></app-header-no-session>

<div class="wrapper">

    <div class="banner-img-name view-top">

        <div class="main" style="padding-bottom: 0;">
            <h2>Preview Application Details</h2>
        </div>

    </div>

    <section class="main">

        <div class="profile-view">

            <table class="h_logo">
                <tr>
                    <td></td>
                    <td><img src="assets/images/logo-nis.png" style="width:140px;"></td>
                    <td></td>
                </tr>
            </table>

            <div class="s-head">

                <div class="result-header">

                    <div class="post-img">
                        <img [src]="bioDetails.passportImageData" >
                    </div>

                    <div class="user-info-detail">

                        <div class="upper_bar" style="border-bottom:1px solid #979797;">
                            <div class="barcode" >
                                <div class="" *ngIf="isPaid === true">
                                    <ngx-barcode [bc-value]="barCodeValue" [bc-display-value]="true" [bc-width]="1" [bc-height]="40" [bc-font-size]="14"></ngx-barcode>
                                </div>
                            </div>

                            <div class="visa_type" style="text-align: right;">

                                <p>Visa on Arrival Application</p>

                                <span style="color:#aaa;">{{generalDetails.visaClass}}</span>
                            </div>
                        </div>

                        <div class="common_view">
                            <div>
                                <label>Full Name</label>
                                <p class="p-body">{{bioDetails.fullName}}</p>
                            </div>

                            <ng-container *ngIf="bioDetails.applicationStatus === constants.STATUS_SUCCESS">
                                <div>
                                    <label>Application No.</label>
                                    <p class="p-body">{{bioDetails.applicationIdV1}}</p>
                                </div>

                                <div>
                                    <label>Reference No.</label>
                                    <p class="p-body">{{bioDetails.referenceIdV1}}</p>
                                </div>
                            </ng-container>

                            <div>
                                <label>Application Date</label>
                                <p class="p-body">{{bioDetails.applicationDate}}</p>
                            </div>

                            <div>
                                <label>Payment Status</label>
                                <p class="p-body"><img [src]="bioDetails.paymentStatusIcon" class="status_img" style="width: 100%; max-width: 51px;"></p>
                            </div>
                        </div>

                    </div>

                </div>

            </div>

            <section id="applicationdetail">

                <div class="s-content">

                    <div class="border_line" style="border: 1px solid #979797;">
                        <p class="p-body  line pb10">Applicant Details</p>
                        <div class="sr-p-info" >
                            <div>
                                <label>Full name</label>
                                <p>{{bioDetails.fullName}}</p>
                            </div>

                            <div>
                                <label>E-mail Address</label>
                                <p>{{bioDetails.email}}</p>
                            </div>

                            <div>
                                <label>Gender</label>
                                <p>{{bioDetails.genderLabel}}</p>
                            </div>

                            <div>
                                <label>Marital Status</label>
                                <p>{{bioDetails.maritalStatusLabel}}</p>
                            </div>

                            <div>
                                <label>Date of Birth</label>
                                <p>{{bioDetails.dateOfBirth}}</p>
                            </div>

                            <div>
                                <label>Place of Birth</label>
                                <p>{{bioDetails.placeOfBirth}}</p>
                            </div>

                            <div>
                                <label>Passport Number</label>
                                <p>{{bioDetails.passportNumber}}</p>
                            </div>

                            <div>
                                <label>Passport Expiry Date</label>
                                <p>{{bioDetails.passportExpiryDate}}</p>
                            </div>
                        </div>
                    </div>

                    <div class="border_line" style="border: 1px solid #979797;">
                        <p class="p-body  line">Visa Details</p>
                        <div class="sr-p-info">
                            <div>
                                <label>Nationality</label>
                                <p>{{generalDetails.nationalityLabel}}</p>
                            </div>

                            <div style="border-bottom: 1px solid #aeaeae !important;">
                                <label>Passport Type</label>
                                <p>{{generalDetails.passportTypeLabel}}</p>
                            </div>

                            <div>
                                <label>Visa Class</label>
                                <p>{{generalDetails.visaClass}}</p>
                            </div>
                        </div>
                    </div>

                    <div class="border_line" style="border: 1px solid #979797;">
                        <p class="p-body  line pb10">Travel Details</p>
                        <div class="sr-p-info" >
                            <div>
                                <label>Purpose of Journey</label>
                                <p>{{travelDetails.journeyPurpose}}</p>
                            </div>

                            <div>
                                <label>Airline</label>
                                <p>{{travelDetails.airlineName}}</p>
                            </div>

                            <div>
                                <label>Flight Number</label>
                                <p>{{travelDetails.flightNumber}}</p>
                            </div>

                            <div>
                                <label>Port of Entry</label>
                                <p>{{travelDetails.entryPortLabel}}</p>
                            </div>

                            <div>
                                <label>Country of Departure</label>
                                <p>{{travelDetails.departureCountryLabel}}</p>
                            </div>

                            <div style="border-bottom: 1px solid #aeaeae !important;">
                                <label>Date of departure(dd/mm/yyyy)</label>
                                <p>{{travelDetails.expectedDepartureDate}}</p>
                            </div>

                            <div>
                                <label>Duration of Stay</label>
                                <p>{{travelDetails.durationOfStay}}</p>
                            </div>
                        </div>
                    </div>

                    <div class="border_line" style="border: 1px solid #979797;">

                        <p class="p-body line pb10">Contact Details</p>

                        <div class="sr-p-info" >

                            <div>
                                <label>Contact Name/ Hotel Name</label>
                                <p>{{contactDetails.contactName}}</p>
                            </div>

                            <div>
                                <label>Contact Number</label>
                                <p>{{contactDetails.dialCode}} {{contactDetails.contactPhone}}</p>
                            </div>

                            <div>
                                <label>Contact E-mail</label>
                                <p>{{contactDetails.contactEmail}}</p>
                            </div>

                            <div>
                                <label>Contact Address</label>
                                <p>{{contactDetails.contactAddress}}, {{contactDetails.contactCity}}, {{contactDetails.contactStateLabel}}, {{contactDetails.contactPostalCode}}</p>
                            </div>
                        </div>

                    </div>

                    <div class="grid_two">

                        <div class="border_line" >

                            <p class="p-body  line pb10">Supporting Documents</p>

                            <div class="tab50">

                                <div *ngFor="let applicationDocument of applicationDocumentsArray;">

                                    <label>{{applicationDocument.label}}</label>

                                    <span class="fr hide"><i (click)="openFileViewModal(applicationDocument.fileBase64Data, applicationDocument.fileType)" class="fa fa-eye" style="color: green; font-size: 15px;"></i></span>

                                </div>

                            </div>

                        </div>

                        <ng-container *ngIf="isShowPaymentDetails === true">

                            <div class="border_line pay_details">

                                <p class="p-body  line pb10">Fee Details</p>

                                <div class="tab50">

                                    <div *ngIf="feeDetails.isGratis === constants.TRUE" class="green_band_gratis">
                                        <span style="font-size:13px;">In view of the existing bilateral agreements/arrangements, your VISA is  on gratis basis and no fee will be charged.</span>
                                    </div>

                                    <div>
                                        <label>Visa Fee</label>
                                        <span class="fr">{{feeDetails.currencySymbol}} {{feeDetails.visaFee}}</span>
                                    </div>

                                    <div *ngIf="feeDetails.addOnCharges > 0">
                                        <label>Biometric Fee</label>
                                        <span class="fr">{{feeDetails.currencySymbol}} {{feeDetails.addOnCharges}}</span>
                                    </div>

                                    <div>
                                        <label>Service Fee</label>
                                        <span class="fr">{{feeDetails.currencySymbol}} {{feeDetails.processingCharges}}</span>
                                    </div>

                                    <div class="total_box" style="border-bottom: 0px;">
                                        <label>Total Fee</label>
                                        <span class="fr">{{feeDetails.currencySymbol}} {{feeDetails.totalCharges}}</span>
                                    </div>

                                </div>

                            </div>

                            <div *ngIf="isPaid === true && feeDetails.visaFee > constants.FALSE" class="border_line pay_details">

                                <p class="p-body  line pb10">Payment Details</p>

                                <div class="tab50">

                                    <div>
                                        <label>Payment Date</label>
                                        <span class="fr">{{paymentDetails.paymentDate}}</span>
                                    </div>

                                    <div>
                                        <label>Payment Gateway</label>
                                        <span class="fr">{{paymentDetails.paymentMode}}</span>
                                    </div>

                                    <div style="border-bottom: 1px solid #d7d7d7 !important;">
                                        <label>Validation Number</label>
                                        <span class="fr">{{paymentDetails.validationNo}}</span>
                                    </div>

                                </div>

                            </div>

                        </ng-container>

                    </div>
                    
                </div>

            </section>

            <div class="view-buttons">

                <input type="button" (click)="backToPage()" value="Close" class="back_btn">

                <input type="button" (click)="printApplication()" value="Print" class="save_btn">

                <input type="button" (click)="printReceipt()" value="Print Receipt" class="custom_btn pay_btn">

                <input type="button" (click)="isShowPaymentDetails = !isShowPaymentDetails" [value]="isShowPaymentDetails === true ? 'Hide Payment Details' : 'Show Payment Details'" class="custom_btn">

            </div>

        </div>

    </section>

</div>

<app-footer class="view-footer"></app-footer>
